import { type ColorScheme } from './styles.ts';

// This is an interface that may be extended to contain additional data.
export interface Section {
  label: string;
  scheme: ColorScheme<string>;
  icon: string;
  href: string;
  /** deprecated: prefer extending this interface with specific criteria */
  hide?: boolean;
}

export function getSection(path: string, sections: Record<string, Section>) {
  for (const section of Object.values(sections)) {
    if (path === section.href) {
      return section;
    }
    if (!section.href.endsWith('/') && path.startsWith(section.href)) {
      return section;
    }
  }
  return undefined; // sections.home;
}
